import React from 'react';
import {BuyerInventoryActivityReportVO} from "../../../types/model/valueObject/inventoryActivity/BuyerInventoryActivityReportVO";
import {BuyerInterchangeCardListItem} from "./BuyerInterchangeCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

export interface BuyerInterchangeCardListProps {
  items?: BuyerInventoryActivityReportVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const BuyerInterchangeCardList = ({
  items,
  expandByIndex,
  onToggleExpand,
}: BuyerInterchangeCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item, index) =>
        <BuyerInterchangeCardListItem
          key={index}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const BuyerInterchangeCardListWithLoader = withLoader(BuyerInterchangeCardList, skeletonLoader);

export {
  BuyerInterchangeCardList,
  BuyerInterchangeCardListWithLoader
};
